"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _v = _interopRequireDefault(require("uuid/v4"));
var _ssrWindow = require("ssr-window");
var _reactTether = _interopRequireDefault(require("react-tether"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _calendar = _interopRequireDefault(require("@spothero/icons/calendar"));
var _dom = _interopRequireDefault(require("@spothero/utils/dom"));
var _DatePickerCalendar = _interopRequireDefault(require("./DatePickerCalendar"));
var _TextInput = _interopRequireDefault(require("../TextInput/TextInput"));
var _Portal = _interopRequireDefault(require("../Portal/Portal"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class DatePicker extends _react.Component {
  static defaultProps = {
    disablePast: true,
    useIcon: true,
    overrideInitialMonthWithSelected: true,
    iconPosition: 'right'
  };
  constructor(props) {
    super(props);
    const {
      id,
      selectedDate
    } = props;
    if (!id) {
      throw new Error(`The prop 'id' is required to make DatePicker accessible for users using assistive technologies such as screen readers. Check the render method of DatePicker.`);
    }
    this._TETHER_CLASS = `DatePicker-tether-${id}`;
    this.state = {
      showCalendar: false,
      selectedDate,
      tetherKey: (0, _v.default)()
    };
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      useTetherShim,
      onChange
    } = this.props;
    const {
      showCalendar,
      selectedDate
    } = this.state;
    const {
      showCalendar: prevShowCalendar,
      selectedDate: prevSelectedDate
    } = prevState;
    if (showCalendar && showCalendar !== prevShowCalendar) {
      _ssrWindow.document.body.addEventListener('mousedown', this._onBodyClick);
      _ssrWindow.document.body.addEventListener('touchstart', this._onBodyClick);
      if (useTetherShim) {
        _dom.default.addClass('html', 'DatePicker-tether-shim-open');
      }
    } else {
      this._removeBodyClickListener();
    }
    if (selectedDate !== prevSelectedDate && onChange) {
      onChange(selectedDate);
    }
  }
  componentWillUnmount() {
    this._removeBodyClickListener();
  }
  _onBodyClick = evt => {
    if ((!_dom.default.parent(evt.target, 'FormElement-control') || !_dom.default.parent(evt.target, `.DatePicker-${this.props.id}`)) && !_dom.default.parent(evt.target, `.${this._TETHER_CLASS}`)) {
      this.setState({
        showCalendar: false
      });
      this.node.blur();
    }
  };
  _onInputFocus = evt => {
    this.setState({
      showCalendar: true
    });
  };
  _onInputChange = selectedDate => {
    this.setState({
      selectedDate
    });
  };
  _onDateChange = selectedDate => {
    this.setState({
      showCalendar: false,
      selectedDate,
      tetherKey: (0, _v.default)()
    });
  };
  _removeBodyClickListener() {
    _ssrWindow.document.body.removeEventListener('mousedown', this._onBodyClick);
    _ssrWindow.document.body.removeEventListener('touchstart', this._onBodyClick);
    if (this.props.useTetherShim) {
      _dom.default.removeClass('html', 'DatePicker-tether-shim-open');
    }
  }

  /**
   * Getter for the input DOM element.
   *
   * @public
   * @returns {Element} - The input element.
   */
  get node() {
    return this._textInput.node;
  }
  render() {
    const {
      className,
      id,
      calendarClassName,
      disabled,
      disablePast,
      disableBefore,
      disableAfter,
      label,
      name,
      useIcon,
      iconPosition,
      placeholder,
      useTetherShim,
      autoFocus,
      focus,
      overrideInitialMonthWithSelected,
      displayFormat,
      ...attrs
    } = this.props;
    const spreadProps = (0, _omit.default)(attrs, ['onChange']);
    const {
      showCalendar,
      tetherKey,
      selectedDate
    } = this.state;
    const classes = (0, _classnames.default)('DatePicker', `DatePicker-${id}`, {
      'DatePicker-disabled': disabled
    }, className);
    const containerClasses = (0, _classnames.default)('DatePicker-input-container', {
      'DatePicker-input-container-with-icon': useIcon
    });
    const tetherClasses = (0, _classnames.default)('DatePicker-tether', {
      'DatePicker-tether-centered-with-shim': useTetherShim
    }, this._TETHER_CLASS);
    const inputDisplay = displayFormat && selectedDate ? displayFormat(selectedDate) : selectedDate;

    /* eslint-disable react/jsx-no-bind */
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: containerClasses
    }, label, /*#__PURE__*/_react.default.createElement(_reactTether.default, {
      key: tetherKey,
      className: tetherClasses,
      attachment: "top left",
      targetAttachment: "bottom left",
      constraints: [{
        to: 'window',
        pin: true
      }],
      renderTarget: ref => {
        return /*#__PURE__*/_react.default.createElement("span", {
          ref: ref
        }, /*#__PURE__*/_react.default.createElement(_TextInput.default, (0, _extends2.default)({
          ref: node => {
            this._textInput = node;
          },
          name: name,
          disabled: disabled,
          defaultValue: inputDisplay,
          onFocus: this._onInputFocus,
          icon: useIcon ? /*#__PURE__*/_react.default.createElement(_calendar.default, {
            className: "Icon-calendar"
          }) : null,
          iconPosition: iconPosition,
          autoFocus: autoFocus,
          focus: focus,
          placeholder: placeholder,
          readOnly: true,
          "aria-label": placeholder
          // TODO: Figure out why `aria-label` attribute gets removed after spreading
        }, spreadProps)));
      },
      renderElement: ref => {
        return showCalendar && /*#__PURE__*/_react.default.createElement(_DatePickerCalendar.default, {
          ref: ref,
          className: calendarClassName,
          onChange: this._onDateChange,
          selectedDate: selectedDate,
          disablePast: disablePast,
          disableBefore: disableBefore,
          disableAfter: disableAfter,
          overrideInitialMonthWithSelected: overrideInitialMonthWithSelected
        });
      }
    }), useTetherShim && showCalendar && /*#__PURE__*/_react.default.createElement(_Portal.default, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "DatePicker-calendar-shim"
    }))));
    /* eslint-ensable react/jsx-no-bind */
  }
}
exports.default = DatePicker;